import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import { util } from '@tencent/vft-common';
export default {
  name: 'pay-button',
  data: function data() {
    return {
      shareCode: util.getUrlParam('shareCode')
    };
  },
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['now', 'payVip']), {
    isLv7: function isLv7() {
      return this.payVip && this.payVip.vip && this.payVip.level === 7;
    }
  }),
  methods: {
    beforePay: function beforePay() {
      if (!this.isLogin) {
        this._openLogin();

        return false;
      }

      var url = '';
      this.rootOpenUrl(url);
      return false;
    }
  }
};